import { compose, setDisplayName, withProps } from 'recompose';
import { DEFAULT_LABEL_LINE_HEIGHT } from '../../const/defaultCSSValues';

import {
  KEY_LABEL_FONT_COLOR,
  KEY_LABEL_FONT_SIZE,
  KEY_LABEL_FONT_STYLE,
  KEY_LABEL_FONT_WEIGHT,
  KEY_LABEL_TEXT_DECORATION,
  KEY_LABEL_TEXT_TRANSFORM,
} from '../../const/keysBlockStyling';

const StylingToCSSLabelText = withProps(
  ({
    styling: {
      [KEY_LABEL_FONT_COLOR]: color,
      [KEY_LABEL_FONT_SIZE]: fontSize,
      [KEY_LABEL_FONT_STYLE]: fontStyle,
      [KEY_LABEL_FONT_WEIGHT]: fontWeight,
      [KEY_LABEL_TEXT_DECORATION]: textDecoration,
      [KEY_LABEL_TEXT_TRANSFORM]: textTransform,
    } = {},
  }) => ({
    styleLabel: {
      color,
      fontSize,
      fontStyle,
      fontWeight,
      lineHeight: DEFAULT_LABEL_LINE_HEIGHT, // prevent fixed line-height of next-ui components @etiurin
      textDecoration,
      textTransform,
    },
  }),
);

export default compose(
  setDisplayName('StylingToCSSLabelText'),
  StylingToCSSLabelText,
);
